// use-push-modal.ts — Layout/modal-stack, sync action
//
//

import { useCallback } from 'react';
import { useModalStackContext } from './modal-stack-context';
import type { ModalEntry } from './modal-stack-types';

export function usePushModal(): (entry: ModalEntry) => void {
  const modalStack = useModalStackContext();
  return useCallback((entry: ModalEntry) => modalStack.push(entry), [modalStack]);
}
